<template lang="pug">
.ExcelLayerCreateLog
  .ExcelLayerCreateLog-content(v-html='log')
  .ExcelLayerCreateLog-footer.ModalFooter
    .ModalFooter-left
      router-link.Btn.Btn--light.Btn--red(
        tag='button',
        :to='{ name: "excel-layer-list" }'
      ) Вернуться к списку слоев
</template>

<script>
export default {
  name: 'ExcelLayerCreateLog',

  computed: {
    layerId() {
      return this.$route.params.layerId
    },

    layerSettings() {
      return this.$store.getters.excelLayerSettings
    },

    log() {
      return this.layerSettings.log.replace('Слой загружен успешно', '').replace(/; /g, ';<br />')
    }
  }
}
</script>

<style scoped lang="scss">
@import '~base';

#app .ExcelLayerHistory {
  --menuColor: #{$grey8};
  --tableBg: #{$grey7};
  --menuLinkColor: #{$blue};
  --tableThColor: #{$grey2};
}

#app[data-theme='dark'] .ExcelLayerHistory {
  --menuColor: #{$grey1};
  --tableBg: #{$black3};
  --menuLinkColor: #{$blue};
  --tableThColor: #{$grey1};
}

.ExcelLayerCreateLog {
  &-content {
    height: calc(100vh - 137px);
    display: flex;
    flex-direction: column;
    padding: 15px;
    overflow: auto;
  }

  &-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/excel-layers/ExcelLayerCreateLog.vue